module.exports = __webpack_public_path__ + "img/noDataAvailable.d947b5b6.jpg";